import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService, ToolbarDetails } from 'src/app/layout/layout.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  userType = this.layoutService.getUserType();

  constructor(
    private layoutService: LayoutService,
    public router: Router
  ) { }
}
